import ActionType from '../action.types'

/*
    Reducer function to push data to the store in case of different events action types
*/
var initialstate = {
  isLoading: false,
  events: [],
  surgerytype: undefined,
  isUpdated: false,
  updatedAt: undefined,
  differences: [],
  changedevents: [],
  tempevents: [],
}

export default function patient_operation(state = initialstate, action) {
  switch (action.type) {
    case ActionType.EVENTS_INPROGRESS:
      return { ...state, isLoading: action.isLoading }
    case ActionType.SET_EVENTS:
      return {
        ...state,
        error: action.hasError,
        events: action.events,
        surgerytype: action.surgerytype,
        changedevents: [],
      }
    case ActionType.EVENT_SERVICE_ERROR:
      return { ...state, error: action.hasError, message: action.message }
    case ActionType.SET_EVENT_UPDATED:
      return {
        ...state,
        isUpdated: action.isUpdated,
        updatedAt: action.updatedAt,
      }
    case ActionType.SET_EVENT_DIFFERENCES:
      return { ...state, differences: action.differences }
    case ActionType.SET_CHANGED_EVENTS:
      return { ...state, changedevents: action.changedevents }
    case ActionType.SET_TEMP_EVENTS:
      return { ...state, tempevents: action.tempevents }
    case ActionType.SET_ISUPDATE:
      return { ...state, isUpdated: action.isUpdated }
    case ActionType.LOGOUT:
      return initialstate
    default:
      return state
  }
}
